"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideSwapper = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SideBySideSwapper = function (_a) {
    var onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp;
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Swap columns" },
        react_1.default.createElement("button", { className: "side-by-side__swapper", onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp },
            react_1.default.createElement(icons_1.Swap, { className: "side-by-side__swapper-icon" }))));
};
exports.SideBySideSwapper = SideBySideSwapper;
